var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { mapValues } from "lodash";
import * as React from 'react';
export var defaultFormStateDefinition = {
  isValid: false,
  // marks if the fields are valid
  isReady: false,
  // marks if the form state is loaded
  isSubmitting: false,
  // marks if the form is submitting
  fields: {}
};
export var FormStateContext = React.createContext(null);
export var FormStateProvider = function (_a) {
  var children = _a.children,
    _b = _a.value,
    value = _b === void 0 ? {} : _b;
  // Add defaults to config to create a definition
  var initialState = mapValues(value, function (formConfig) {
    return __assign(__assign({}, defaultFormStateDefinition), formConfig || {});
  });
  var _c = __read(React.useState(initialState), 2),
    state = _c[0],
    setState = _c[1];
  var patchForm = function (formName, options) {
    return function (patch) {
      setState(function (prevState) {
        var _a;
        var _b = options || {},
          _c = _b.mode,
          mode = _c === void 0 ? 'merge' : _c,
          onChange = _b.onChange;
        var prevFormState = prevState[formName] || defaultFormStateDefinition;
        // If there is a field patch, we need to ensure that the field set is a new object
        // this is so we can setup validators and other effects to watch for changes
        // importantly though, we should reference the previous field state if it's a different patch
        // as a validator might set isValid based on field changes, and if the fields change here again, 
        // the validator would re-check, re-set ... infinite loop 
        var prevFields = patch.fields ? __assign({}, prevFormState.fields || {}) : prevFormState.fields || {};
        var newFields = mode !== 'replace' ? prevFields : {};
        var patchFields = patch.fields || {};
        for (var fieldName in patchFields) {
          var patchState = patchFields[fieldName];
          var newFormFieldState = __assign(__assign(__assign({}, prevFields[fieldName] || {}), patchState), {
            // if mutationValue is not provided, use the current value
            // this allows for special values to be provided for mutation only
            mutationValue: patchState.mutationValue || patchState.value
          });
          newFields[fieldName] = newFormFieldState;
        }
        var newFormState = __assign(__assign(__assign({}, prevFormState), patch), {
          fields: newFields
        });
        // allow a callback to respond to changes - this is the most accurate place to retrieve current state
        if (onChange) {
          onChange(newFormState);
        }
        return __assign(__assign({}, prevState), (_a = {}, _a[formName] = newFormState, _a));
      });
    };
  };
  var contextValue = {
    state: state,
    setState: setState,
    patchForm: patchForm
  };
  return React.createElement(FormStateContext.Provider, {
    value: contextValue
  }, children);
};